/* globals urls, themeObj, Grid */

(function($) {

	//	add single event to schedule
	$('.add-event-to-schedule').click(function(e){

		e.preventDefault();
	    $.ajax({
	        type: "POST",
	        url: urls.ajax,
	        data: {
	            action : 'addScheduleEventToCalendar',
	            title : $(this).data('title'),
	            location: $(this).data('location'),
	            start_time : $(this).data('start_time'),
	            end_time : $(this).data('end_time'),
	            cal_start_time : $(this).data('cal_start_time'),
	            cal_end_time : $(this).data('cal_end_time')
	        },
	        success: function(data){
	            $.magnificPopup.open({
					mainClass: 'mfp-with-zoom',
	                type: 'inline',
	                items: {
	                    src: data
	                }
	            });
				$('.popup-cancel-btn').on('click', function () {
					$.magnificPopup.close();
				});
				$('#iCal').on('click', function(e){
					e.preventDefault();
					$('#ics').submit();
				});
				$('#outlook').on('click', function(e){
					e.preventDefault();
					$('#ics').submit();
				});
	        }
	    });
	});
	
	//	add all events to schedule
    $('.schedule-all').click(function(e){

		e.preventDefault();
	    $.ajax({
	        type: "POST",
	        url: urls.ajax,
	        data: {
	            action : 'addScheduleEventBlockToCalendar',
                day:$(this).data('day'),
                post:$(this).data('post')
	        },
	        success: function(data){
	            $.magnificPopup.open({
					mainClass: 'mfp-with-zoom',
	                type: 'inline',
	                items: {
	                    src: data
	                }
	            });
				$('.popup-cancel-btn').on('click', function () {
					$.magnificPopup.close();
				});
				$('#iCal').on('click', function(e){
					e.preventDefault();
					$('#ics-all').submit();
				});
				$('#outlook').on('click', function(e){
					e.preventDefault();
					$('#ics-all').submit();
				});
	        }
	    });
    });

})( jQuery );